import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import {
  SlideToggleFieldInput,
  SlideToggleFieldOutput,
} from '@trackback/widgets';
import { BaseFormControlWidgetComponent } from '../base-form-control-widget.component';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Register('SlideToggleField')
@Component({
  selector: 'tb-slide-toggle-field',
  templateUrl: './slide-toggle-field.component.html',
  styleUrls: ['./slide-toggle-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    AsyncPipe,
    ParsePipe,
  ],
})
export class SlideToggleFieldComponent
  extends BaseFormControlWidgetComponent<
    SlideToggleFieldInput,
    SlideToggleFieldOutput
  >
  implements OnInit {}
